/** Number formatting shared by both Campaign Leaks tabs. */

export const DASH = '—';

export const getLocale = () => localStorage.getItem('i18nextLng') || 'en';

/** Amount in the workspace currency: 0 decimals from 100 up, 2 below. */
export const formatMoney = (value: number, currency: string, locale = getLocale(), decimals?: number) => {
  const digits = decimals ?? (Math.abs(value) >= 100 ? 0 : 2);
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(value);
};

export const formatInteger = (value: number, locale = getLocale()) =>
  new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(value);

/** Conversions: rounded, no decimal. */
export const formatConversions = (value: number) => formatInteger(Math.round(value));

/** Ratio without currency (ROAS): 2 decimals. */
export const formatRatio = (value: number, locale = getLocale()) =>
  new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);

/** "Oct 22 – Oct 28, 2026" (in the user's language) from two ISO dates, with both years when they differ. */
export const formatDateRange = (start: string, end: string) => {
  const s = new Date(`${start}T00:00:00`);
  const e = new Date(`${end}T00:00:00`);
  const locale = getLocale();
  const md = (d: Date) => d.toLocaleDateString(locale, { month: 'short', day: 'numeric' });
  const mdy = (d: Date) => d.toLocaleDateString(locale, { month: 'short', day: 'numeric', year: 'numeric' });
  return s.getFullYear() === e.getFullYear() ? `${md(s)} – ${mdy(e)}` : `${mdy(s)} – ${mdy(e)}`;
};
